import { auth } from './chunk-YECUXW6K.js';
import { __name } from './chunk-7QVYU63E.js';

// src/util/permissions/index.ts
function accountHas(entitlement) {
  const session = auth.getCache();
  if (!session) {
    return false;
  }
  return session.features.includes(entitlement);
}
__name(accountHas, "accountHas");
function userCan(...args) {
  const action = args[0];
  const level = args[1];
  const permission = args[2];
  const siteId = level === "site" ? args[3] : void 0;
  const readonlyFactors = typeof args[3] === "object" ? args[3] : typeof args[4] === "object" ? args[4] : void 0;
  const session = auth.getCache();
  if (!session) {
    return false;
  }
  if (
    // If some external factor is setting read-only state
    readonlyFactors && Object.values(readonlyFactors).some((state) => state === true)
  ) {
    if (
      // Only 'view' actions are allowed
      action !== "view"
    ) {
      return false;
    }
  }
  let allowedActions = [];
  if (level === "account") {
    allowedActions = session.permissions.actions[permission] ?? [];
  }
  if (level === "site") {
    const site = session.sites.find(({ site_id }) => site_id === siteId);
    if (!site) {
      throw new Error("Undefined: site!");
    }
    allowedActions = site.permissions.actions[permission] ?? [];
  }
  return allowedActions.includes(action);
}
__name(userCan, "userCan");
userCan.site = (permission, siteId, readonlyFactors) => {
  return {
    canView: userCan("view", "site", permission, siteId, readonlyFactors),
    canCreate: userCan("create", "site", permission, siteId, readonlyFactors),
    canEdit: userCan("edit", "site", permission, siteId, readonlyFactors),
    canDelete: userCan("delete", "site", permission, siteId, readonlyFactors)
  };
};
userCan.account = (permission, readonlyFactors) => {
  return {
    canView: userCan("view", "account", permission, readonlyFactors),
    canCreate: userCan("create", "account", permission, readonlyFactors),
    canEdit: userCan("edit", "account", permission, readonlyFactors),
    canDelete: userCan("delete", "account", permission, readonlyFactors)
  };
};
var permissions = {
  userCan,
  accountHas
};

export { accountHas, permissions, userCan };
//# sourceMappingURL=chunk-XLHR3UCL.js.map
//# sourceMappingURL=chunk-XLHR3UCL.js.map